import { AppRouteProps } from "@bsm/component";
import InvoiceListViewerContainer from "./container/InvoiceListViewerContainer"
import { InvoiceListViewerSignatoriesRoutes } from "./views/signatories/InvoiceListViewerSignatoriesRoutes";
import { InvoiceListViewerEmailRoutes } from "./views/email/InvoiceListViewerEmailRoutes";

export const InvoiceListViewerRoutes: Array<AppRouteProps> = [
    {
        path: "viewer",
        element: <InvoiceListViewerContainer />,
        children: [
            ...InvoiceListViewerSignatoriesRoutes,
            ...InvoiceListViewerEmailRoutes,
        ],
    },
];